import React from "react";
import Compose from "./compose";

import {
  BlogProvider,
  AuthProvider,
  ContactProvider,
  EventProvider,
  MetaProvider,
  FaqProvider,
  NewsProvider,
} from "../src/contexts";

export const AppWrapper = ({ children }) => {
    const allProviders = [
      BlogProvider,
      AuthProvider,
      ContactProvider,
      EventProvider,
      MetaProvider,
      FaqProvider,
      NewsProvider
    ];

    return (
        <React.Fragment>
          <Compose providers={allProviders}>{children}</Compose>  
        </React.Fragment>
      );
};